import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const createLawValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    description: yup
      .string()
      .required()
      .max(INPUT_LENGTH.MAX_INPUT_LENGTH_XL, i18n.t("validation.name.charCount.invalid")),
  });
};
